import React from 'react';
import { Helmet } from 'react-helmet';

const SITE_URL = 'https://locopilot.bixbite.ai';
const DEFAULT_OG_IMAGE = `${SITE_URL}/monogram.png`;

const SeoMeta = ({
  title,
  description,
  canonicalPath = '/',
  keywords,
  ogType = 'website',
  schema,
  siteName = 'LoCoPilot',
}) => {
  const canonicalUrl = new URL(canonicalPath, SITE_URL).toString();
  const schemaPayload = schema ? JSON.stringify(schema) : null;

  return (
    <Helmet>
      <title>{siteName}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:site_name" content={siteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />

      {schemaPayload ? (
        <script type="application/ld+json">
          {schemaPayload}
        </script>
      ) : null}
    </Helmet>
  );
};

export default SeoMeta;
